import { render, staticRenderFns } from "./ManageAcademies.vue?vue&type=template&id=5a34da98&scoped=true"
import script from "./ManageAcademies.vue?vue&type=script&lang=js"
export * from "./ManageAcademies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a34da98",
  null
  
)

export default component.exports